import { type HTMLAttributeAnchorTarget } from 'react'
import { useRouter } from 'next/router'
import Link from 'next/link'

import { Icon, IconName, Typography } from '@themenu/design-system'

import { PERMISSIONS } from 'components/Authorize'

export type GroupItemButtonProps = {
  href?: string
  id: string
  action?: () => void
  target?: HTMLAttributeAnchorTarget
  label: string
  icon?: string
  testId?: string
  active?: boolean
  permission: PERMISSIONS[]
}

export const GroupItemButton = ({
  href,
  id,
  label,
  icon = undefined,
  testId,
  target = '_self',
  action,
  ...props
}: GroupItemButtonProps) => {
  const { route } = useRouter()

  if (action) {
    return (
      <li className="mb-4" {...props}>
        <button
          className="w-full flex items-center gap-12 px-14 py-8 hover:bg-background-default rounded-8"
          onClick={action}
          title={label}
          data-testid={testId}
          id={id}
        >
          <span className="w-16 h-16">
            {icon && <Icon name={icon as IconName} size={16} />}
          </span>
          <Typography variant="footnote">{label}</Typography>
        </button>
      </li>
    )
  }

  const active = route === href || route.startsWith(href ?? '')

  return (
    <li className="mb-4" {...props}>
      <Link
        href={href as string}
        title={label}
        data-testid={testId}
        target={target}
        id={id}
        className={`flex items-center gap-12 px-14 py-8 hover:bg-background-default rounded-8
          ${active ? 'bg-background-default' : ''}`}
      >
        <span className="w-16 h-16">
          {icon && <Icon name={icon as IconName} size={16} />}
        </span>
        <Typography
          variant="footnote"
          className={active ? 'text-content-primary' : ''}
        >
          {label}
        </Typography>
      </Link>
    </li>
  )
}
